package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Paint
import com.starparty.app.astro0.celestialobjects.CelestialBody
import com.starparty.app.astro0.celestialobjects.DSO

open class RendererTheme(val backgroundPaint: SP_Paint,
                         val constellationsPaint: SP_Paint,
                         val constellationTitlesPaint: SP_Paint,
                         val constellationBoundaryPaint: SP_Paint,
                         val celestialBodyPaint: SP_Paint,
                         val darkPhasePaint: SP_Paint,
                         val altAzmGridPaint: SP_Paint,
                         val altAzmGridLabelsPaint: SP_Paint,
                         val altAzmZeroGridPaint: SP_Paint,
                         val equGridPaint: SP_Paint,
                         val equGridLabelsPaint: SP_Paint,
                         val equZeroGridPaint: SP_Paint,
                         val equatorPaint: SP_Paint,
                         val horizonPaint: SP_Paint,
                         val centreMarkerPaint: SP_Paint
    ){

    protected val backgroundColour = SP_Colour(0,0,0,255) // BLACK

    protected val constellationColor = SP_Colour(90, 90, 255,255) //Color.blue;
    protected val constellationTitleColor = SP_Colour(0,255,255, 255) // CYAN
    protected val constellationBoundaryColor = SP_Colour(0, 255, 255, 90)

    protected val dsoColour = SP_Colour(0, 255, 0, 255)

    protected val darkPhasePaintColor = SP_Colour(50,50,50,255)

    protected val equGridColor = SP_Colour(120, 120, 120, 200)
    protected val equZeroGridColor = SP_Colour(120, 200, 200, 200)
    protected val altAzmGridColor = SP_Colour(0, 255, 255, 120)
    protected val altAzmZeroGridColor = SP_Colour(0,255,255,200) //CYAN
    protected val equatorColor = SP_Colour(255,255,255,255)
    protected val horizonColor = SP_Colour(0,255,0, 255) //GREEN
    protected val altAzmGridLabelColor = SP_Colour(255,255,255,255) // WHITE

    protected val gridLabelTextSize = 20.0f
    protected val equGridLabelColour = SP_Colour(255, 255, 255, 255)

    protected var centreMarkerColour = SP_Colour(255, 255, 255, 255)

    val celestialBodyFullLabelFontSize = 12.0f
    val celestialBodyAbbrevLabelFontSize = 12.0f

    val orbitalBodyAbbrevLabelFontSize = 20.0f


    init {
        backgroundPaint.setColour(backgroundColour)

        constellationsPaint.setColour(constellationColor)
        constellationTitlesPaint.setColour(constellationTitleColor)
        constellationBoundaryPaint.setColour(constellationBoundaryColor)

        darkPhasePaint.setColour(darkPhasePaintColor)

        altAzmGridPaint.setColour(altAzmGridColor)
        altAzmZeroGridPaint.setColour(altAzmZeroGridColor)
        horizonPaint.setColour(horizonColor)

        equGridPaint.setColour(equGridColor)
        equZeroGridPaint.setColour(equZeroGridColor)
        equatorPaint.setColour(equatorColor)

        altAzmGridLabelsPaint.setColour(altAzmGridLabelColor)
        equGridLabelsPaint.setColour(equGridLabelColour)

        altAzmGridLabelsPaint.setTextSize(gridLabelTextSize)
        equGridLabelsPaint.setTextSize(gridLabelTextSize)

        centreMarkerPaint.setColour(centreMarkerColour)
    }

    public open fun setDSOColour(dso: DSO) {
        celestialBodyPaint.setColour(dsoColour)
    }
    public open fun setCelestialBodyColour(cb: CelestialBody) {
        celestialBodyPaint.setColour(cb.rgbColour)
    }
}